<template>
  <BasicModal
    :title="createRoboName"
    :isShowModal="isCardModalActive"
    :canCancel="false"
    :width="'1000px'"
    @cancel="cancel">
    <!-- アラート -->
    <div class="alert-box">
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <div v-if="isPreparation">
      <header class="card-header">
        <p class="card-header-title">
          ただいま準備中です。<br>
          しばらくお待ちください。
        </p>
      </header>
    </div>
    <div v-else-if="isFinishingFlag">
      <header class="card-header">
        <p class="card-header-title">
          ただいま確定しています。<br>
          しばらくお待ちください。
        </p>
      </header>
    </div>
    <div v-else class="card" style="border-radius: 5px;">
      <header class="card-header">
        <p class="card-header-title">
          このテンプレートは{{editPartsListLength()}}パーツの編集およびパーツ確定が必要です。（{{getConfirmPartsNum()}}パーツ確定済み / 全{{editPartsListLength()}}パーツ）
        </p>
        <div class="return-button-box">
          <button
            class="button is-primary return-button"
            @click="cancel(false)"
          >
            <span class="mdi mdi-undo"></span>
            戻る
          </button>
        </div>
      </header>
      <div class="card-content" v-if="editPartsListLength() > 0">
        <p class="parts-name">{{partsName}}（{{selectedEditPartsIndex + 1}}パーツ目 / 全{{editPartsListLength()}}パーツ）</p>
        <div class="parts-content">
          <!-- 前へボタン -->
          <div>
            <a v-if="isPreviewParts()" @click="previewParts()"><span class="mdi mdi-play mdi-rotate-180 mdi-48px"></span></a>
            <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-play mdi-rotate-180 mdi-48px"></span></a>
          </div>
          <!-- 会話シナリオ編集 -->
          <div class="editor-area disp-scroll">
            <ScenarioEditor />
          </div>
          <!-- 次へボタン -->
          <div>
            <a v-if="isNextParts()" @click="nextParts()"><span class="mdi mdi-play mdi-48px"></span></a>
            <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-play mdi-48px"></span></a>
          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        このテンプレートは、準備・編集することなくお使いいただくことができます。<br>
        「準備完了・ロボを雇用する」ボタンをクリックすると、ロボを雇用することができます。<br>
      </div>
      <div class="card-footer">
        <a class="card-footer-item" @click="clickCreateRobo()">準備完了・ロボを雇用する</a>
      </div>
    </div>
  </BasicModal>
</template>

<script>
import { mapState }     from 'vuex'
import BasicModal       from '@/components/Modals/BasicModal'
import ScenarioEditor   from '@/components2/Robo/modal/organisms/ScenarioEditor'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import controlLogMixin  from '@/mixins/controlLogMixin'
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラート表示データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'

export default {
  name: 'TemplateToRobo',
  componentName: 'TemplateToRobo',
  components: {
    BasicModal,
    ScenarioEditor,
    ModalAlertDialog,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    /**
     * ダイアログ開閉フラグ
     * @type {Object}
     */
    isCardModalActive: {
      type: Boolean,
      default: false,
      required: true
    },
    /**
     * 作成ロボ名
     * @type {String}
     */
    createRoboName: {
      type: String,
      default: '',
      required: true
    },
    /**
     * テンプレートロボ
     * @type {Object}
     */
    templateRobo: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type {String}
       */
      COMPONENT_NAME: 'TemplateToRobo',
      /**
       * 準備中フラグ
       * @type {Boolean}
       */
      isPreparation: false,
      /**
       * 作成完了中フラグ
       * @type {Boolean}
       */
      isFinishingFlag: false,
      /**
       * アラートダイアログ表示フラグ(true：表示、false：非表示)
       * @type {Boolean}
       */
      isAlertDialogOpen: false,
      /**
       * アラートダイアログ表示データ
       * @type {Object}
       */
      alertData: {},
      /**
       * エラーフラグ
       * @type {Boolean}
       */
      isError: false,
      /**
       * 新規作成ロボ
       * @type {Object}
       */
      newRobo: null,
      /**
       * 新規シナリオリスト
       * @type {Array}
       */
      newScenarioList: [],
      /**
       * 編集シナリオパーツ
       * @type {Array}
       */
      editPartsList: [],
      /**
       * 選択中編集パーツインデックス
       * @type {Number}
       */
      selectedEditPartsIndex: 0,
      /**
       * 選択中編集パーツ
       * @type {Object}
       */
      selectedEditParts: null,
    }
  },
  computed: {
    ...mapState('chatbot', ['modalScenario']),
    /**
     * 編集パーツ名取得
     */
    partsName () {
      let partName = ''
      switch (this.selectedEditParts.status) {
        case 0:
          partName = '選択肢ありメッセージパーツ'
          break
        case 1:
          partName = '応募フォームパーツ'
          break
        case 2:
          partName = 'メッセージのみパーツ'
          break
        case 3:
          partName = 'ロボ切替パーツ'
          break
        case 4:
          partName = '日程自動調整パーツ'
          break
        case 5:
          partName = '画像パーツ'
          break
        case 6:
          partName = '自由入力パーツ'
          break
        case 7:
          partName = 'ファイルアップロードパーツ'
          break
        case 8:
          partName = '履歴書フォームパーツ'
          break
        case 9:
          partName = '最初からパーツ'
          break
        case 10:
          partName = 'メール送付パーツ'
          break
        case 11:
          partName = '欠番'
          break
        case 12:
          partName = '条件分岐パーツ'
          break
        case 13:
          partName = 'チェックボックスパーツ'
          break
        case 14:
          partName = '動画パーツ'
          break
        case 15:
          partName = 'プルダウンパーツ'
          break
        case 16:
          partName = 'SMS送付パーツ'
          break
        case 17:
          partName = 'カルーセル選択パーツ'
          break
        case 18:
          partName = 'ファイルダウンロードパーツ'
          break
        case 19:
          partName = '回答出力パーツ'
          break
        case 20:
          partName = '検索パーツ'
          break
        case 21:
          partName = 'PDFダウンロードパーツ'
          break
        case 22:
          partName = '付箋パーツ'
          break
        default:
          partName = '不明'
          break
      }
      return partName
    }
  },
  watch: {
    isCardModalActive () {
      if (this.isCardModalActive) {
        // テンプレートロボのシナリオパーツをコピーする
        this.isPreparation = true
        const copyInfo = {
          robo_name: this.createRoboName,
          template_robo_id: this.templateRobo.bot_id
        }
        this.$store.dispatch('chatbot/copyTemplateRobo', copyInfo)
          .then(newRobo => {
            if (newRobo.status && newRobo.status === false) {
              this.showError(
                'エラーが発生しました。',
                newRobo.message,
                'close-only'
              )
            } else if (newRobo.status && newRobo.status === true){
              // 画像と動画、タグが追加されている場合があるので、読み込みなおしておく
              this.$store.dispatch('mediapool/getAllImages')
              this.$store.dispatch('mediapool/getAllVideos')
              this.$store.dispatch('chatbot/getChatBotTag', null)

              // ロボとシナリオを取得
              this.newRobo = newRobo.robo
              this.newScenarioList = newRobo.scenario

              // 編集パーツを抽出(ロックされていないパーツ)
              this.editPartsList = this.newScenarioList.filter(parts => !parts.is_confirm)

              // パーツ初期選択
              this.selectedEditPartsIndex = 0
              this.selectScenario()
            } else {
              this.showError(
                'エラーが発生しました。',
                '不明なエラーが発生しました。',
                'close-only'
              )
            }
          })
          .catch(error => {
            console.error(error)
            this.showError(
              'エラーが発生しました',
              '画面準備中にエラーが発生しました。',
              'close-only'
            )
          })
          .finally(() => {
            this.isPreparation = false
          })
      }
    },
    modalScenario () {
      let updatePartsIndex = -1
      // シナリオ編集ダイアログが切り替わったら、編集パーツリストを更新する
      this.editPartsList.map(
        (parts, index) => {
          if (parts.beforenode === this.modalScenario.beforenode) {
            updatePartsIndex = index
          }
        }
      )
      if (updatePartsIndex >= 0 && updatePartsIndex < this.editPartsList.length) {
        this.editPartsList[updatePartsIndex] = this.modalScenario
      }
    }
  },
  methods: {
    /**
     * キャンセル
     */
    cancel () {
      this.showConfirm(
        '破棄されます！',
        'キャンセルすると、編集中の内容が破棄されます。\nキャンセルしますか？',
        'cancel-scenario-edit'
      )
    },
    /**
     * ロボ作成ダイアログ開閉
     */
    showDialog (flag) {
      this.isShowRoboCreate = flag
    },
    /**
     * 編集パーツ数取得
     */
    editPartsListLength () {
      if (this.editPartsList && this.editPartsList.length > 0) {
        return this.editPartsList.length
      } else {
        return 0
      }
    },
    /**
     * 準備完了チェック
     */
    checkRemainingWork () {
      // 全ての編集パーツを確定したらOK
      const comfirmedParts = this.editPartsList.filter(parts => parts.is_confirm === true).length
      if (comfirmedParts === this.editPartsList.length) {
        // 全パーツ確定済み
        return true
      } else {
        // 未確定パーツあり
        return false
      }
    },
    /**
     * 次パーツ遷移可能チェック
     */
    isNextParts () {
      if (this.selectedEditPartsIndex < this.editPartsList.length - 1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 前パーツ遷移可能チェック
     */
    isPreviewParts () {
      if (this.selectedEditPartsIndex <= 0) {
        return false
      } else {
        return true
      }
    },
    /**
     * 次パーツ遷移
     */
    nextParts () {
      this.selectedEditPartsIndex++
      this.selectScenario()
    },
    /**
     * 前パーツ遷移
     */
    previewParts () {
      this.selectedEditPartsIndex--
      this.selectScenario()
    },
    /**
     * パーツ遷移
     */
    selectScenario () {
      if (this.editPartsList.length > 0) {
        this.selectedEditParts = this.editPartsList[this.selectedEditPartsIndex]
        if (this.selectedEditParts) {
          this.$store.dispatch('chatbot/selectScenario', this.selectedEditParts)
        }
      }
    },
    /**
     * 確定済みパーツ数取得
     */
    getConfirmPartsNum () {
      return this.editPartsList.filter(parts => parts.is_confirm === true).length
    },
    /**
     * ロボ新規作成
     */
    clickCreateRobo () {
      if (this.checkRemainingWork()) {
        // 全パーツ確定済み
        this.isFinishingFlag = true
        this.newRobo.is_confirm = true
        // 全パーツ確定済みならロボをロックする
        this.$store.dispatch('chatbot/setChatBot', this.newRobo)
          .then(() => {
            this.showToast(
              '準備・編集完了',
              '新たなロボを雇用しました！\n\n雇用ロボ名：' + this.createRoboName,
              'close-only'
            )
          })
          .catch(() => {
            this.isFinishingFlag = false
            this.sendControlLogRelatedChatBot('ロボ雇用', 'テンプレートロボから新たにロボ雇用時、エラー発生。', this.newRobo)
          })
      } else {
        // 未確定パーツあり
        this.showConfirm(
          '準備・編集未完了',
          'まだ未編集および未確定のパーツがあります。\n' +
          'このままロボを雇用して、シナリオ編集画面で編集することも可能です。\n' +
          'シナリオ編集画面に移動しますか？',
          'create-confirm'
        )
      }
    },
    /**
     * アラートダイアログ表示
     */
    showToast (title, message, keyword) {
      // アラート表示データ
      const alertData = createAlertData(
        // タイトル
        title,
        // 本文
        message,
        // アラートの種類
        ALERT_DEF.MESSAGE_INFO,
        // ダイアログの種類
        ALERT_DEF.DIALOG_ALERT,
        // 表示元キーワード
        this.COMPONENT_NAME,
        // 表示元分類キーワード
        keyword
      )

      // アラート表示
      this.alertData = alertData
      this.isAlertDialogOpen = true
    },
    /**
     * 確認アラートダイアログ表示
     */
    showConfirm (title, message, keyword) {
      // アラート表示データ
      const alertData = createAlertData(
        // タイトル
        title,
        // 本文
        message,
        // アラートの種類
        ALERT_DEF.MESSAGE_WARNING,
        // ダイアログの種類
        ALERT_DEF.DIALOG_CONFIRM,
        // 表示元キーワード
        this.COMPONENT_NAME,
        // 表示元分類キーワード
        keyword
      )

      // アラート表示
      this.alertData = alertData
      this.isAlertDialogOpen = true
    },
    /**
     * エラーアラートダイアログ表示
     */
    showError (title, message, keyword) {
      // アラート表示データ
      const alertData = createAlertData(
        // タイトル
        title,
        // 本文
        message,
        // アラートの種類
        ALERT_DEF.MESSAGE_DANGER,
        // ダイアログの種類
        ALERT_DEF.DIALOG_ALERT,
        // 表示元キーワード
        this.COMPONENT_NAME,
        // 表示元分類キーワード
        keyword
      )

      // アラート表示
      this.alertData = alertData
      this.isAlertDialogOpen = true
    },
    /**
     * アラートダイアログ操作結果
     * @param {Object} alertResultData アラートダイアログ操作結果
     */
    alertResult (alertResultData) {
      if (alertResultData) {
        if (alertResultData.alertKeyFunction === this.COMPONENT_NAME) {
          if (alertResultData.alertKeyWord === 'cancel-scenario-edit') {
            // キャンセル確認結果
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // キャンセル実行
              // 編集中のロボとシナリオを削除
              this.$store.dispatch('chatbot/deleteCopyRobo', this.newRobo.scenario_name)
              this.$emit('cancel', false)
              this.sendControlLogRelatedChatBot('ロボ雇用', 'ロボの雇用をキャンセル。', this.newRobo)
            }
          }
          else if (alertResultData.alertKeyWord === 'close-only') {
            // ロボ雇用確認結果
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_OK) {
              // シナリオ編集画面に遷移
              this.$store.dispatch('chatbot/selectChatbot', this.newRobo)
              this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.newRobo.scenario_name)
              this.$emit('cancel', false)
              this.sendControlLogRelatedChatBot('ロボ雇用', 'テンプレートロボから新たにロボを雇用。', this.newRobo)
            }
          }
          else if (alertResultData.alertKeyWord === 'create-confirm') {
            // ロボ雇用確認結果
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // シナリオ編集画面に遷移
              this.$store.dispatch('chatbot/selectChatbot', this.newRobo)
              this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.newRobo.scenario_name)
              this.$emit('cancel', false)
              this.sendControlLogRelatedChatBot('ロボ雇用', 'パーツの編集または確定せずにロボを雇用。', this.newRobo)
            }
          }
          // アラートダイアログを閉じる
          this.isAlertDialogOpen = false
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.return-button-box {
  padding: 8px;
  padding-right: 32px;
  margin-right: 10px;
}
.return-button {
  height: 32px;
  position: absolute;
  right: 18px;
}
.editor-area {
  width: 100%;
  height: calc(100vh - 400px);
}
.card-content {
  .parts-name {
    font-size: 24;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .parts-content {
    justify-content: center;
    margin-right: auto;
    display: flex;
    align-items: center;
    position: relative;
    .turn-button {
      height:200px;
      width:20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/TemplateToRobo.vue